import React, { useState } from 'react';
import './PartnershipSection.css';
import carSvg from '../assets/partnership-car.png';
import tireTrack from '../assets/tire-track.png';

const PartnershipSection = () => {
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
  e.preventDefault();
  setStatus('Sending...');

  try {
    const response = await fetch('https://driveincarspa.com/submit-partnership.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `phone=${encodeURIComponent(phone)}`
    });

    const text = await response.text();
    if (response.ok) {
      alert('Form submitted successfully!');
      setStatus('Thank you! We’ll be in touch.');
      setPhone('');
    } else {
      alert('Submission failed. Please try again.');
      setStatus('Submission failed. Please try again.');
    }
  } catch (error) {
     alert('Form submitted successfully!');
      setStatus('Thank you! We’ll be in touch.');
  }
};


  return (
    <section className="partnership-section container mx-auto">
      <div className="partnership-bg-tire">
        <img src={tireTrack} alt="Tire Track" />
      </div>
      <div className="partnership-content">
        <h2 className="partnership-title">Start Your<br />Partnership Today</h2>
        <div className="partnership-subtitle">
          Collaborate, grow, and unlock new opportunities together.
        </div>
        <form className="partnership-form" onSubmit={handleSubmit}>
          <input
            type="tel"
            className="partnership-input"
            placeholder="Phone Number"
            maxLength={15}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
          <button className="partnership-send-btn" type="submit">SEND</button>
        </form>
        {status && <p className="partnership-status">{status}</p>}
      </div>
      <div className="partnership-bg-car">
        <img src={carSvg} alt="Car" />
      </div>
    </section>
  );
};

export default PartnershipSection;
